// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"d50a8a358bc12ac353ac","151":"55e47d5e2d624e6050ed","307":"663d327732e601661e0b"}[chunkId] + ".js";
};